module.exports = __webpack_public_path__ + "img/lampa-4.b076e210.jpg";